import { destroy, get, post, put } from './index';
import qs from 'qs';

export const createToConnectionRequestModel = ({ payload }) =>
  post('/to-connection-request-models', payload);

export const updateToConnectionRequestModel = ({ id, payload }) =>
  put(`/to-connection-request-models/${id}`, payload);

export const getToConnectionRequestModels = ({ filters } = {}) =>
  get(`/to-connection-request-models?${qs.stringify(filters)}`);

export const getOneToConnectionRequestModel = ({ id }) =>
  get(`/to-connection-request-models/${id}`);

export const deleteToConnectionRequestModel = ({ id }) =>
  destroy(`/to-connection-request-models/${id}`);
